import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Servicio para gestionar eventos relacionados con la visibilidad de widgets en la vista.
 * Actúa como un canal de comunicación entre componentes, permitiendo emitir y suscribirse
 * a eventos de widgets visibles o fuera de pantalla.
 */
@Injectable({
  providedIn: 'root', // Hace que el servicio esté disponible en toda la aplicación como un singleton.
})
export class ScreenViewService {
  /**
   * Sujeto reactivo para gestionar eventos de visibilidad de widgets.
   * Permite emitir y observar el estado de visibilidad de los widgets en la vista.
   */
  public widgetCancelRequest: Subject<{ id: number; onScreen: boolean }> = new Subject();

  /**
   * Mapa para rastrear el estado actual de visibilidad de cada widget.
   */
  public widgetVisibilityState: { [key: number]: boolean } = {};

  /**
   * Constructor del servicio.
   *
   * Inicializa el servicio como singleton para gestionar la visibilidad de los widgets.
   */
  constructor() {}
}
